import { uploadmedia } from "../../../Apimanager/Networking";
import { fetchMutation, fetchQuery } from "../../../actions";
import { GET_USER_DATA_WITH_APPOINTMENT } from "../../../actions/userQueries";
import { setEpicDetails } from "../../../redux/actions/epic.action";
import { store } from "../../../redux/store";
import { GET_SIGNED_URL_V2 } from "../../notes-fhir/actions/notesAct";
import { GET_NOTES_DATA } from "../../notes/actions/notesAct";
import { LIMIT } from "../../notes/constent/ConstentVariable";

export const getNotesByPatientId = (patientId, callBack = () => {}) => {
   fetchQuery(
      GET_NOTES_DATA,
      {
         notes: {
            limit: 50,
            offset: 0,
            search: "",
            patientId: patientId,
         },
      },
      (result) => {
         callBack(result);
      },
      (err) => {
         callBack(null);
      }
   );
};

export const getSelectedPatientProfile = (patientId, callback = () => []) => {
   const payload = {
      options: {
         id: patientId,
      },
   };

   fetchQuery(
      GET_USER_DATA_WITH_APPOINTMENT,
      payload,
      (data) => {
         let patientProfile = data?.data?.getProfile;
         callback(patientProfile);
      },
      (error) => {
         callback(null);
      }
   );
};

export const uploadEpicJson = (jsonRes, id) => {
   if (jsonRes) {
      const params = new URLSearchParams();
      params.append("grant_type", "refresh_token");
      params.append("refresh_token", jsonRes.refreshToken);
      params.append("client_id", clientIdVariable());
      params.append("client_secret", clientSecretVariable());

      fetch(jsonRes.tokenEndpoint, {
         method: "POST",
         body: params,
         headers: {
            "Content-Type": "application/x-www-form-urlencoded",
         },
      })
         .then((response) => response.json())
         .then((data) => {
            let jsonResNew = {
               ...jsonRes,
               refreshToken: data.refresh_token,
               accessToken: data.access_token,
            };
            store.dispatch(setEpicDetails(jsonResNew));
            const jsonData = JSON.stringify(jsonResNew);

            // Create a Blob object from the JSON string
            const blob = new Blob([jsonData], { type: "application/json" });
            let notesObj = {
               noteId: id,
               fileName: "epicCred.json",
            };
            fetchMutation(GET_SIGNED_URL_V2, notesObj, (res) => {
               const url = res?.data?.getCreateNotesSignedUrl?.signedUrl;
               uploadmedia(url, blob)
                  .then(() => {})
                  .catch((error) => {});
            });
         })
         .catch((error) => {
            console.error("Error:", error);
         });
   }
};

export const clientIdVariable = () => {
   return process.env.REACT_APP_EPIC_CLIENT_ID;
};
export const clientSecretVariable = () => {
   return process.env.REACT_APP_EPIC_CLIENT_SECRET;
};
